import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/home',
}).lazy(() => import('./home.lazy').then((d) => d.Route))
